import { plugin, Mode } from 'light-component';
import { useTranslation } from '../../../i18n';
import { Thumbnail } from '../../component';
import { WidgetType } from '../types';
import { CheckBoxInputMode } from './input';
import { CheckBoxDesignMode } from './design';
import { CheckBoxPropsViewMode } from './view';
import type { ReactElement } from 'react';
import type { CheckBoxProps } from './types';

export function CheckBox(props: CheckBoxProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='CheckBoxIcon' title={t('CheckBox')} toolTipContent={t('CheckBox')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<CheckBoxDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<CheckBoxPropsViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<CheckBoxInputMode {...props} />);
  }

  return null;
}

CheckBox.prototype.type = WidgetType.CHECKBOX;
plugin.register({ kind: 'widget', component: CheckBox });
